// extracted by mini-css-extract-plugin
export default {"whatWeDo":"WhatWeDo_whatWeDo__2Bxe1","title":"WhatWeDo_title__IMNKQ","options":"WhatWeDo_options__cMfNI","btn":"WhatWeDo_btn__9Ln7n","icon":"WhatWeDo_icon__1-6wl"};